import { features } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">为什么选择皮皮喵</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">用心打造的漫画阅读体验，让你追更更轻松</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((feature) => (
            <div key={feature.id} className="bg-background-100 rounded-xl p-6 border border-background-200/50 hover:border-primary-200/50 transition-colors text-center">
              <div className="w-12 h-12 mx-auto mb-4 rounded-xl bg-primary-100 flex items-center justify-center">
                <span className="w-6 h-6 flex items-center justify-center">
                  <i className={`${feature.icon} text-primary-500 text-xl`}></i>
                </span>
              </div>
              <h3 className="text-base font-bold text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}